import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotifications } from '../contexts/NotificationContext';
import { Bell, X } from 'lucide-react';

const VIEW_COUNT_KEY = 'find2day_biz_views';
const PROMPT_DISMISSED_KEY = 'find2day_follow_prompt_dismissed';
const VIEW_THRESHOLD = 3;

const FollowPromptBanner = () => {
  const { t } = useTranslation();
  const notifications = useNotifications();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Don't show if already subscribed and following businesses
    if (notifications?.isSubscribed && notifications?.preferences?.followedBusinessIds?.length > 0) return;
    // Don't show if dismissed this session
    if (sessionStorage.getItem(PROMPT_DISMISSED_KEY)) return;

    const views = parseInt(sessionStorage.getItem(VIEW_COUNT_KEY) || '0', 10);
    if (views >= VIEW_THRESHOLD) {
      const timer = setTimeout(() => setShow(true), 800);
      return () => clearTimeout(timer);
    }
  }, [notifications?.isSubscribed, notifications?.preferences?.followedBusinessIds]);

  const dismiss = () => {
    sessionStorage.setItem(PROMPT_DISMISSED_KEY, '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="bg-gradient-to-r from-purple-50 to-indigo-50 border border-purple-200 rounded-xl p-4 mb-6 animate-slide-up" data-testid="follow-prompt-banner">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 bg-purple-100 rounded-lg flex items-center justify-center flex-shrink-0">
          <Bell className="h-4.5 w-4.5 text-purple-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-800">{t('followPromptTitle')}</p>
          <p className="text-xs text-gray-500 mt-0.5">{t('followPromptDesc')}</p>
        </div>
        <button onClick={dismiss} className="text-gray-400 hover:text-gray-600 p-0.5 flex-shrink-0" data-testid="follow-prompt-dismiss" aria-label="Dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

/** Call this from BusinessDetail on mount to increment the view counter */
export const trackBusinessView = () => {
  const current = parseInt(sessionStorage.getItem(VIEW_COUNT_KEY) || '0', 10);
  sessionStorage.setItem(VIEW_COUNT_KEY, String(current + 1));
};

export default FollowPromptBanner;
